import { useSelector } from "react-redux";

let profileStore;

const getStoredUserProfile = () => {
  if (typeof localStorage === "undefined") return {};

  try {
    return JSON.parse(localStorage.getItem("userProfile") || "{}");
  } catch (error) {
    return {};
  }
};

export const selectUserProfile = (state) => {
  const user = state?.profileReducer?.user || {};
  const fullProfile = user.userProfile || getStoredUserProfile();

  return {
    ...fullProfile,
    _id: fullProfile._id ?? user.id,
    name: fullProfile.name ?? user.name,
    EmailAddress: fullProfile.EmailAddress ?? user.email,
    Profiles: fullProfile.Profiles ?? user.profile ?? {},
    Professions: fullProfile.Professions ?? user.profession ?? [],
    profile: fullProfile.profile ?? user.profile ?? {},
  };
};

export const setProfileStore = (store) => {
  profileStore = store;
};

export const getUserProfile = () => {
  if (!profileStore) {
    return selectUserProfile({});
  }

  return selectUserProfile(profileStore.getState());
};

export const useUserProfile = () => useSelector(selectUserProfile);
